import { defineMessages } from "react-intl";

export default defineMessages({
  md5Checksum: {
    id: "page.downloads.entry.md5Checksum",
    defaultMessage: "MD5 Checksum",
    description: "",
  },
  sha1Checksum: {
    id: "page.downloads.entry.sha1Checksum",
    defaultMessage: "SHA1 Checksum",
    description: "",
  },
  download: {
    id: "page.downloads.entry.link.download",
    defaultMessage: "Download",
    description: "",
  },
  downloadIsDisabled: {
    id: "page.downloads.entry.downloadIsDisabled",
    defaultMessage: "Download for this file is currently disabled",
    description: "",
  },
});
